import React from 'react';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {useBookingMachine} from '../../hooks/useBookingMachine';


export const BookingRescheduleFormBackButton = () => {
  const {bookingActor, bookingState} = useBookingMachine();

  const isRescheduleFormSubmittingState = bookingState.matches({
    rescheduleForm: 'rescheduleFormSubmitting',
  });

  const handleRescheduleReasonFormBack = () => {
    bookingActor.send({type: 'rescheduleReasonForm.back'});
  };

  return (
    <Button
      size="small"
      type="tertiary"
      onClick={handleRescheduleReasonFormBack}
      iconRightName="chevron-left"
      disabled={isRescheduleFormSubmittingState}
    />
  );
};
